import axios from 'axios';
import GO1_API from '../../src/config/api';
import store from "../store/store";

export default {

  industriesPromise: null,
  countriesPromise: null,
  // try to find the supplied industry in our list of accepted industries
  findIndustry(possibleIndustry) {
    return this.industries().then(industries => {
      return industries.find(industry => industry.toLowerCase() === possibleIndustry.toLowerCase());
    });
  },

  // determine if industry exists
  hasIndustry(possibleIndustry) {
    return this.findIndustry(possibleIndustry)
      .then(industry => industry !== undefined);
  },

  // try to find the supplied country in our list of accepted countries
  findCountry(possibleCountry) {
    return this.countries().then(countries => {
      return countries.find(country => country.code.toLocaleLowerCase() === possibleCountry.toLocaleLowerCase());
    });
  },

  // determine if country exists
  hasCountry(possibleCountry) {
    return this.findCountry(possibleCountry)
      .then(country => country !== undefined);
  },

  // get default country to pre-select
  defaultCountry() {
    return {code: "AU", name: "Australia"};
  },

  // get default industry to pre-select
  defaultIndustry() {
    return "Other Services";
  },

  industries() {
    if (!this.industriesPromise) {
      this.industriesPromise = axios.get(`${GO1_API}portal/properties/industry`).then(
        response => {
          response.data.sort();
          return response.data;
        },
        () => {
          this.industriesPromise = null;
        }
      )
    }
    return this.industriesPromise;
  },

  countries() {
    // registrations coming from Totara will be handled the old way for the time being, because we are using the old api which accepts only the region
    if (store.state.client_id === 'totara') {
      return Promise.resolve([
        { code: "AU", name: "Australia" },
        { code: "EU", name: "European Union" },
        { code: "MY", name: "Malaysia" },
        { code: "UK", name: "United Kingdom" },
        { code: "US", name: "United States of America" },
        { code: "OTHER", name: "Rest of the world" }
      ]);
    }
    if (!this.countriesPromise) {
      this.countriesPromise = axios.get(`${GO1_API}portal/properties/country`).then(
        response => {
          const countries = [];
          Object.keys(response.data).forEach(function (key) {
            countries.push({ code: key, name: response.data[key]});
          });
          countries.sort((a, b) => a.name < b.name ? -1 : 1);
          return countries;
        },
        () => {
          this.countriesPromise = null;
        }
      )
    }
    return this.countriesPromise;
  },
}



// WEBPACK FOOTER //
// ./src/services/OptionService.js